import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ComparablesTabs } from '../../enum';
import { NavigationBase } from '../../navigation-base';
import { NavigationService } from '../../navigation.service';
import { EventBusService } from '../../../services/event-bus.service';
/**
 * Handles the comparables navigation component
 */
@Component({
  selector: 'comparables-navigation',
  templateUrl: './comparables-navigation.component.html'
})
export class ComparablesNavigationComponent extends NavigationBase implements OnInit {
  /**
   * Constructor
   * @param ref
   * @param navigationService
   */
  constructor(ref: ChangeDetectorRef,
    private navigationService: NavigationService,
    eventBus: EventBusService) {
    super(eventBus, ref);
  }
  /**
   * On events array
   */
  protected onEvents: Array<any> = [];
  /**
   * Selected tab
   */
  selectedTab: ComparablesTabs = ComparablesTabs.Properties;
  /**
   * Search tab visible flag
   */
  searchTabVisible = false;
  /**
   * Search mode
   */
  searchMode = 'comparablesProperty';
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    super.ngOnInit();
  }
  /**
   * Redirect to
   * @param tab
   */
  redirectTo(tab: string) {
    this.setSelectedTab(tab);
    this.eventBus.broadcastEvent('comparablesTabSelect', tab);
    this.eventBus.broadcastEvent('searchBarVisibility', false, '');
    this.searchTabVisible = false;
  }
  /**
   * Get active tab
   */
  public get activeTab(): typeof ComparablesTabs {
    return ComparablesTabs;
  }
  /**
   * Set selected tab
   * @param tab
   */
  private setSelectedTab(tab: string) {
    switch (tab) {
      case 'tabProperty':
        this.selectedTab = ComparablesTabs.Properties;
        this.searchMode = 'comparablesProperty';
        break;
      case 'tabValuation':
        this.selectedTab = ComparablesTabs.Valuations;
        this.searchMode = 'comparablesValuation'
        break;
      case 'tabLeases':
        this.selectedTab = ComparablesTabs.Leases;
        this.searchMode = 'comparablesLease';
        break;
    }
    this.navigationService.setActiveComparablesTab(this.selectedTab);
  }
  /**
   * Set search bar visibility
   */
  setSearchBarVisibility() {
    this.searchTabVisible = !this.searchTabVisible;
    this.eventBus.broadcastEvent('searchBarVisibility', this.searchTabVisible, this.searchMode);
  }
}
